<template>
  <Header />

  <div id="appCapsule">
    <div class="login-form mt-5">
      <div class="section">
        <img width="180" src="assets/img/iran-min.png" alt="avatar" class="img-fluid" />
      </div>
      <div class="section mt-3">
        <!-- <h2>ایران ترابر رانندگان</h2> -->
      </div>
      <div class="section mt-3 mb-5" style="margin-top: 50%">
        <form
          id="app"
          @submit.prevent="checkForm"
          action="https://vuejs.org/"
          method="post">
          <div class="form-group boxed">
            <div class="input-wrapper">
              <label class="form-label" for="mobileNumber"
                >لطفا شماره موبایل خود را وارد کنید</label
              >
              <input
                type="tel"
                class="form-control"
                id="mobileNumber"
                name="mobileNumber"
                autofocus
                v-model="postData.mobileNumber"
                placeholder="مثال 09120000000"
                autocomplete="off"
              />
              <i class="clear-input">
                <ion-icon
                  name="close-circle"
                  role="img"
                  class="md hydrated"
                  aria-label="close circle"
                ></ion-icon>
              </i>
            </div>
          </div>

          <div class="form-group mt-2 mb-3" style="text-align: right">
            <div class="form-check mb-1">
              <input
                type="checkbox"
                class="form-check-input"
                id="acceptTerm"
                v-model="postData.acceptTerm"
              />

              <label class="form-check-label" for="acceptTerm">
                با ورود به ایران ترابر
                <router-link class="text-warning" to="/terms-and-conditions">
                  قوانین و مقررات
                </router-link>
                را میپذیرم.
              </label>
            </div>
          </div>
          <ul v-if="errors.length" style="text-align: right">
            <div v-for="error in errors" :key="error" class="invalid-feed">
              {{ error }}
            </div>
          </ul>

          <div class="form-button-group">
            <button
              v-if="loading == false"
              class="btn background-ORANGE text-light btn-block btn-lg"
            >
              درخواست کد فعال سازی
            </button>
            <button
              v-else
              class="btn background-ORANGE text-light btn-block btn-lg"
              type="button"
              disabled
            >
              <span
                class="spinner-border spinner-border-sm me-05"
                role="status"
                aria-hidden="true"
              ></span>
              درحال بررسی ...
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "@/components/header.vue";
import axios from "axios";

export default {
  components:{
    Header
  },
  data() {
    return {
      errors: [],
      postData: {
        mobileNumber: "",
        acceptTerm: null,
      },
      loading: false,
    };
  },
  methods: {
    checkForm() {
      if (this.postData.mobileNumber && this.postData.acceptTerm) {
        this.createPost();
      }

      this.errors = [];

      if (!this.postData.mobileNumber) {
        this.errors.push("شماره موبایل اجباری است.");
      }
      if (!this.postData.acceptTerm) {
        this.errors.push("قبول قوانین و مقررات اجباری است.");
      }
    },
    createPost() {
      this.loading = true;
      axios
        .post(
          "https://core.iran-tarabar.ir/api/requestActivationCode",
          this.postData
        )
        .then((response) => {
          this.loading = false;
          if (response.data.result == 1) {
            this.$router.replace({
              name: "verify",
              params: { mobileNumber: this.postData.mobileNumber },
            });
          } else {
            this.loading = false;
            alert(response.data.result);
          }
        });
    },
  },
};
</script>

<style scoped>
.invalid-feed {
  display: block;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: #dc3545;
}
.form-check .form-check-label:after {
  border: 1px solid black;
}
</style>